// Company "Apply" list for Algonest.
//
// SINGLE SOURCE OF TRUTH: companies.json (sibling file).
// To add or update companies, edit src/data/companies.json, then rebuild & redeploy.
// Each entry is { "name": "...", "url": "<careers/jobs portal>" }.
//
// Aggregated & de-duplicated from these open-source, freely-shared lists — thank you:
//   - moreThanFAANGM (Kaustubh Natuskar)   https://github.com/Kaustubh-Natuskar/moreThanFAANGM
//   - List_OF_Companies (nawabsahab16)      https://github.com/nawabsahab16/List_OF_Companies
//   - Visa-sponsor companies (idontknowjs)  https://gist.github.com/idontknowjs/22f3257bed32dd3ab99ff22316e51eb8
import companies from "./companies.json";

export default companies;